<template>
  <transition name="calendar-fade">
    <div class="calendar" v-show="state===1" @touchmove.prevent>
      <transition name="calendar-move">
        <div class="calendar-panel" v-if="state===1" @click.stop>
          <div class="calendar-bar">
            <div class="calendar-barTop">
              <div class="back" @click="back">
                <img src="/static/img/left2.png" />
              </div>
              <div class="calendar-tips">
                <div>{{$t('share.calendarDataTitle')}}</div>
                <div>{{$t('share.calendarDataExplain')}}</div>
              </div>
              <div class="reset"></div>
              <!-- <div @click="Reset">{{$t('system_modules_calendar_zhongzhi')}}</div> -->
            </div>
            <div class="calendar-center" v-if="datas.length>1">
              <div style="height:0.37rem" v-for="data in datas"
                :class="{'active':selectDateCodes==data.key?true:false}">
                <div :style="{'font-size':data.value!=''?'0.3192rem':'0.425rem'}">{{data.title}}</div>
                <div style="font-size: 0.372rem;">{{data.value}}</div>
              </div>
            </div>
            <div class="calendar-barBottom">
              <ul class="weeks-wrapper">
                <li class="weeks-item" v-for="weekList in weekLists">{{weekList}}</li>
              </ul>
            </div>
          </div>
          <Scroll ref="scroll" :ScrollIndex="ScrollIndex">
            <ul class="calendar-content">
              <li v-for="month in months">
                <div class="calendar-title">{{month.month}}</div>
                <div class="calendar-days" v-for="week,w in month.weeks" v-if="w<6">
                  <div class="calendar-day" @click="selectDate(day)" v-for="day,i in week"
                    :class="{'selectDate':day.dateFormat==date,'disable':disableDate(day)}">
                    <!-- 'disable':datas[0].isScope&&today>day.dateFormat||
                   (datas[0].isScope&&datas[0].isScope&&datas.length>1&&selectDateCode=='ArriveDate'&&day.dateFormat<=datas[0].value)||
                   (datas[0].isScope&&day.dateFormat<datas[0].minDate||datas[0].isScope&&day.dateFormat>=datas[0].maxDate), -->
                    <div class="calendar-dayItem" v-if="month.month==day.nowMonth">
                      <div>{{day.date.getDate()}}</div>
                      <div>{{day.lunar}}</div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </Scroll>
        </div>
      </transition>
    </div>
  </transition>
</template>
<style scoped>
  .calendar {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 100;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: rgba(37, 38, 45, .4);

  }

  .calendar-left ul .activeTab {
    background-color: #fff;
  }

  .border-top-1px,
  .border-right-1px,
  .border-bottom-1px,
  .border-left-1px {
    position: relative
  }

  .border-bottom-1px:before,
  .border-bottom-1px:after,
  .border-top-1px:before,
  .border-top-1px:after {
    content: "";
    display: block;
    position: absolute;
    transform-origin: 0 0;
  }


  .border-top-1px:before {
    border-top: 1px solid #ebebeb;
    left: 0;
    top: 0;
    width: 100%;
    transform-origin: 0 top;
    width: 200%;
    transform: scale(.5) translateZ(0)
  }

  .border-top-1px:after {
    width: 200%;
    content: "";
    display: block;
    position: absolute;
    transform-origin: 0 0;
    transform: scale(.5) translateZ(0)
  }

  .border-bottom-1px:after {
    border-top: 1px solid #ebebeb;
    left: 0;
    bottom: 0;
    width: 200%;
    content: "";
    display: block;
    position: absolute;
    transform-origin: 0 0;
    transform: scale(.5) translateZ(0)
  }


  .calendar-fade-enter,
  .calendar-fade-leave-active {
    opacity: 0
  }

  .calendar-fade-enter-active,
  .calendar-fade-leave-active {
    transition: all .3s ease-in-out;
  }

  .calendar-panel {
    position: absolute;
    z-index: 600;
    bottom: 0;
    width: 100%;
    height: 100%;
    background: #fff
  }

  .calendar-move-enter,
  .calendar-move-leave-active {
    transform: translate3d(0, 100%, 0)
  }

  .calendar-move-enter-active,
  .calendar-move-leave-active {
    transition: all .5s ease-in-out
  }

  .appInner .calendar-barTop {
    padding-top: 0.532rem
  }

  .appInner .calendar-content {
    padding-bottom: 1.35rem
  }

  .iphoneX .calendar-barTop {
    padding-top: 1.064rem
  }

  .iphoneX .calendar-content {
    padding-bottom: 1.55rem
  }

  .calendar-content {
    padding-bottom: 1.15rem
  }

  .calendar-barTop {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1.06rem 0.266rem 0;
    background-color: #12a3ff;
    color: #fff;
    height: 1.489rem;
    position: relative;

  }

  .calendar-tips {
    margin: 0 auto
  }

  .calendar-barTop>div:first-child,
  .calendar-barTop>div:last-child {
    width: 1.330rem;
    position: absolute;
    height: 1.489rem;
    line-height: 1.489rem
  }

  .back {
    left: 0.266rem;

  }

  .reset {
    right: 0.266rem;
  }

  .back img {
    width: 0.425rem;
    vertical-align: middle;
  }

  .calendar-center {
    display: flex;
    align-items: center;
    justify-content: space-around;
    background-color: #fff;
    color: #12a3ff;
    padding-top: 0.03rem
  }

  .calendar-center>div {
    flex: 2;
    text-align: center;
  }

  .calendar-tips {
    text-align: center;
  }

  .calendar-tips>div:first-child {
    font-size: 0.372rem;
  }

  .calendar-tips>div:last-child {
    font-size: 0.3192rem;
    color: #f5f5f5
  }

  .calendar-title {
    text-align: center;
    padding: 0.133rem 0;
    background-color: #f5f5f5
  }

  .weeks-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-around;
    font-size: 0.372rem;
    padding: 0.02rem 0;
    color: black;
  }

  .weeks-item {
    flex: 7;
    text-align: center
  }

  .calendar-days .calendar-today {
    background-color: #12a3ff;
    color: #fff;
  }

  .calendar-days {
    display: flex;
    justify-content: space-around;
    align-items: center;
    color: #666;
  }

  .calendar-day {
    flex: 7
  }

  .calendar-dayItem {
    margin: 0px;
    text-align: center;
    font-weight: 400;
    position: relative;
    padding: 0.133rem 0;
  }

  .calendar-dayItem>div:first-child {
    font-size: 0.425rem;
  }

  .calendar-dayItem>div:last-child {
    font-size: 0.11rem;
  }

  .calendar-today .calendar-dayItem>div:last-child {
    color: #fff;
  }

  .active {
    box-sizing: border-box;
    border-bottom: 0.02rem solid #12a3ff;
  }

  .calendar-days .disable {
    color: #e3e3e3;
  }

  .calendar-days .selectDate {
    background-color: #12a3ff;
    color: #fff;
  }
</style>

<script>
  import {
    getRect
  } from './dom'
  import calendar from './calendar.js'
  window.calendar = calendar;
  import Scroll from './Scroll.vue'
  import BScroll from 'better-scroll'
  const STATE_HIDE = 0
  const STATE_SHOW = 1
  const COMPONENT_NAME = 'calendar'
  export default {
    name: COMPONENT_NAME,
    data() {
      return {
        state: STATE_HIDE,
        weekLists: [this.$root.$t('system_modules_calendar_ri') , this.$root.$t('system_modules_calendar_yi') , this.$root.$t('system_modules_calendar_er') , this.$root.$t('system_modules_calendar_san') , this.$root.$t('system_modules_calendar_si') , this.$root.$t('system_modules_calendar_wu') , this.$root.$t('system_modules_calendar_liu') ],
        datas: [],
        today: moment().format("YYYY-MM-DD"),
        day: new Date().getDate(),
        months: [],
        date: 0,
        index: 0,
        cloneDatas: [],
        ScrollIndex: 0,
        ResetData: {},
      }
    },
    props: {
      data: {
        type: Array,
        default() {
          return []
        }
      },
      title: {
        type: String
      },
      cancelTxt: {
        type: String,
      },
      confirmTxt: {
        type: String,
      },
      selectedIndex: {
        type: Array,
        default() {
          return []
        }
      },
      monthScope: {
        type: Number,
        default() {
          return 0
        }
      },

    },
    mounted() {
      let __self = this;
      $(window).bind('popstate', function () {
        __self.hide();
      })
    },
    methods: {
      disableDate(day) {
        let __self = this;
        let Flag = false;
        for (let i = 0; i < __self.datas.length; i++) {
          let data = __self.datas[i];
          if (data.isScope && __self.today > day.dateFormat) {
            Flag = true;
          }
          if (data.key == __self.selectDateCodes) {
            if (data.isScope) {
              if ((day.dateFormat < data.minDate || day.dateFormat >= data.maxDate)||(__self.selectDateCode=='ArriveDate'&&day.dateFormat<__self.datas[0].value)) {
                Flag = true;
              }
            }
          }
        }
        return Flag;
      },
      // dateParse(date) {
      //   if (!date) {
      //     return '';
      //   }
      //   return dateUtils.DateFormat(date, "yyyy-MM-dd");
      // },
      lunar(date) {
        if (date.getMonth() + 1 == 1 && date.getDate() == 1) {
          return this.$root.$t('system_modules_calendar_yuandan') ;
        }
        if (date.getMonth() + 1 == 4 && date.getDate() == 4) {
          return this.$root.$t('system_modules_calendar_qingmingjie') ;
        }
        if (date.getMonth() + 1 == 5 && date.getDate() == 1) {
          return this.$root.$t('system_modules_calendar_laodongjie') ;
        }
        if (date.getMonth() + 1 == 10 && date.getDate() == 1) {
          return this.$root.$t('system_modules_calendar_guoqingjie') ;
        }
        var tl = calendar.solar2lunar(date.getFullYear(), date.getMonth() + 1, date.getDate());
        if (tl.lMonth == 12 && tl.lDay == 30) {
          return this.$root.$t('system_modules_calendar_chuxi') ;
        }
        if (tl.lMonth == 1 && tl.lDay == 1) {
          return this.$root.$t('system_modules_calendar_chunjie') ;
        }
        if (tl.lMonth == 5 && tl.lDay == 5) {
          return this.$root.$t('system_modules_calendar_duanwujie') ;
        }
        if (tl.lMonth == 8 && tl.lDay == 15) {
          return this.$root.$t('system_modules_calendar_zhongqiujie') ;
        }
        return tl.lDay == 1 ? tl.IMonthCn : tl.IDayCn;
      },
      readerCalendar() {
        let __self = this;
        let Data = {}
        for (let i = 0; i < __self.datas.length; i++) {
          if (__self.selectDateCode == __self.datas[i].key) {
            Data = __self.datas[i];
          }
        }
        __self.date = Data.value;
        let selectDate = moment(__self.date);
        let monthDay = moment(selectDate).add(1 - moment(selectDate).date(), 'days').toDate(); //当月的第一天
        var weekDay = monthDay.getDay();
        var startDate = moment(monthDay).add(1 - weekDay, 'days');
        var months = []
        for (let i = 0; i < __self.monthScope + 1; i++) {
          var date = {
            month: moment(Data.minDate).year(Number).add(i, 'months').format('YYYY-MM'),
            weeks: [
              [],
              [],
              [],
              [],
              [],
              []
            ]
          };
          var oneDay = moment(date.month).date(1); //.weekday(); // 获取当月1日为星期几
          var oneWeekday = oneDay.weekday(); // 获取当月1日为星期几
          var monthDate = oneDay.subtract(oneWeekday, 'days');
          for (let i = 0; i < 6; i++) {
            for (let j = 0; j < 7; j++) {
              let sourceDate = new Date(monthDate);
              date.weeks[i].push({
                date: sourceDate,
                dateFormat: monthDate.format("YYYY-MM-DD"),
                lunar: __self.lunar(sourceDate),
                nowMonth: sourceDate = moment(sourceDate).format('YYYY-MM')
              })
              monthDate.add(1, 'days');
            }
          }
          months.push(date);
        }
        __self.months = months;
      },
      selectDate(day) {
        let __self = this;
        for (let i = 0; i < __self.datas.length; i++) {
          if (__self.datas[i].isScope && __self.datas[i].key == __self.selectDateCodes) {
            if (day.dateFormat < __self.today) {
              return
            }
            if (day.dateFormat < __self.datas[i].minDate) {
              return
            }
            if (day.dateFormat >= __self.datas[i].maxDate) {
              return
            }
          }
          // if (__self.datas[i].isScope && (day.dateFormat < __self.today || day.dateFormat < __self.datas[i].minDate ||day.dateFormat >= __self.datas[i].maxDate)) {
          //   return 
          // }
          if (__self.datas[i].isScope && __self.selectDateCode != 'DepartDate' && __self.datas[i].key == 'DepartDate' && day.dateFormat < __self.datas[i].value) {
            return
          }
          let data = __self.datas[i];
          if (!data.isSelected) {
            continue;
          }
          data.value = day.dateFormat;
          if (data.key == __self.selectDateCode) {
            __self.date = data.value
          }
          if (i + 1 == __self.datas.length) {
            __self.$emit('change', __self.datas, __self.calendarIndex);
            setTimeout(function () {
              __self.hide();
              history.back();
            }, 300)
            return;
          }
          data.isSelected = false;
          __self.datas[i + 1].isSelected = true;
          break;
        }
      },
      show() {
        let __self = this;
        __self.state = STATE_SHOW;
        history.pushState({}, '', location.href);
        let date = moment(__self.date).format('YYYY-MM')
        for (let i = 0; i < __self.months.length; i++) {
          let month = __self.months[i].month
          if (month == date) {
            __self.ScrollIndex = i
          }
        }
        __self.readerCalendar();
      },
      back() {
        let __self = this;
        // __self.datas = __self.cloneDatas;
        history.back();
        __self.hide();
      },
      hide() {
        this.state = STATE_HIDE;
      },
      setData(data) {
        let __self = this;
        __self.datas = data;
        __self.cloneDatas = _.cloneDeep(__self.datas)
        __self.readerCalendar()
      },
      Reset() { }
    },
    computed: {
      selectDateCodes() {
        let __self = this;
        for (let i = 0; i < __self.datas.length; i++) {
          let data = __self.datas[i];
          if (data.isSelected) {
            return data.key;
          }
        }
        return "";
      },
      selectDateCode() {
        return this.selectDateCodes;
      },
    },
    watch: {
      selectDateCode() {

      },
      data(newData, oldData) {
        this.setData(newData);
      },

    },
    components: {
      Scroll
    }
  }

</script>